import { MesfModal } from "@dexteel/mesf-core";
import { Alert, Box, Button, Typography } from "@mui/material";

interface Props {
	open: boolean;
	/** e.g. "(Angle) L3x3x1/4" */
	productLabel: string;
	/** e.g. "Night setup · v4" */
	recipeLabel: string;
	onCancel: () => void;
}

// The confirmation Send to PLC will ask for. The write to the PLC does not exist
// yet (MILL.SendStraightenerRecipeToPlc was never written), so the confirm stays
// disabled and says so instead of pretending to send.
export const SendToPlcConfirmModal = ({
	open,
	productLabel,
	recipeLabel,
	onCancel,
}: Props) => (
	<MesfModal
		id="straightener-send-to-plc"
		title="Send to PLC?"
		open={open}
		handleClose={onCancel}
		maxWidth="sm"
	>
		<MesfModal.Content dividers style={{ padding: "15px 30px" }}>
			<Typography>
				This action will send the set points of <strong>{recipeLabel}</strong>{" "}
				for <strong>{productLabel}</strong> to the PLC.
			</Typography>
			<Alert severity="info" sx={{ mt: 2 }}>
				Sending set points to the PLC is not enabled yet.
			</Alert>
		</MesfModal.Content>
		<MesfModal.Actions style={{ padding: "20px 30px 30px" }}>
			<Box
				sx={{
					display: "flex",
					justifyContent: "flex-end",
					gap: 2,
					width: "100%",
				}}
			>
				<Button variant="contained" color="inherit" onClick={onCancel}>
					Cancel
				</Button>
				<Button variant="contained" color="success" disabled>
					Send to PLC
				</Button>
			</Box>
		</MesfModal.Actions>
	</MesfModal>
);
